<script lang="ts" setup>
defineProps({
  steps: {
    type: Array,
    default: []
  },
  stepKey: {
    type: String,
    default: 'step'
  },
  stepColor: {
    type: String,
    default: 'red' // || blue
  }
});

const getFlexClass = (stepsLength: number, index: number) => {
  switch (stepsLength) {
    case 1:
      return 10;
    case 2:
      return 5;
    case 3:
      return 3;
    case 4:
      return 2;
    default:
      return index + 1; // Just in case there are more steps than expected
  }
}
</script>

<template>
  <div class="steps-flow" v-if="steps.length" :class="`box-${stepColor}`">
    <div class="steps-flow-content flex wrap" :class="`${steps.length === 1 ? 'center' : 'justify'}`">
      <template v-for="(step, index) in steps" :key="step[stepKey]">
        <div class="step-item" v-if="step[stepKey]" :class="`flex_${getFlexClass(steps.length, index)}`">
          <div class="step-arrow hide-mobile" v-if="(index+1) !== steps.length"><img src="/images/arrows/decor-arrow-next.svg"
                                                                         alt="arrow-next"/></div>
          <span class="step-index">{{ `0${index + 1}` }}</span>
          <p>{{ step[stepKey] }}</p>
          <div class="step-arrow hide-desktop hide-ipad-p hide-medium" v-if="index !== 0"><img src="/images/arrows/decor-arrow-1.svg"
                                                                                     alt="arrow-next"/></div>
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="scss">
@import "assets/css/source/components/steps_text_flow";
</style>